export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SESSION_EXPIRED = "SESSION_EXPIRED";

// signup actions
export const SIGNUP_START = "SIGNUP_START";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_ERROR = "SIGNUP_ERROR";

// subDomain  check
export const DOMAIN_START = "DOMAIN_START";
export const DOMAIN_SUCCESS = "DOMAIN_SUCCESS";
export const DOMAIN_ERROR = "DOMAIN_ERROR";

// subdomain register check
export const DOMAIN_REG_START = "DOMAIN_REG_START";
export const DOMAIN_REG_SUCCESS = "DOMAIN_REG_SUCCESS";
export const DOMAIN_REG_ERROR = "DOMAIN_REG_ERROR";

// email request for password
export const EMAIL_REQ_START = "EMAIL_REQ_START";
export const EMAIL_REQ_SUCCESS = "EMAIL_REQ_SUCCESS";
export const EMAIL_REQ_ERROR = "EMAIL_REQ_ERROR";

// PASSWORD SET
export const PASSWORD_SET_START = "PASSWORD_SET_START";
export const PASSWORD_SET_SUCCESS = "PASSWORD_SET_SUCCESS";
export const PASSWORD_SET_ERROR = "PASSWORD_SET_ERROR";

//  All Apps
export const APP_LIST_START = "APP_LIST_START";
export const APP_LIST_COUNT = "APP_LIST_COUNT";
export const APP_LIST_ERROR = "APP_LIST_ERROR";

// Dashboard
export const DASHBOARD_START = "DASHBOARD_SET_START";
export const DASHBOARD_SUCCESS = "DASHBOARD_SET_SUCCESS";
export const DASHBOARD_COUNT_SUCCESS = "DASHBOARD_COUNT_SUCCESS";
export const DASHBOARD_FILTER = "DASHBOARD_SET_FILTER";
export const DASHBOARD_ERROR = "DASHBOARD_SET_ERROR";
export const QUICK_ACTIONS = "QUICK_ACTIONS";
export const QUICK_ACTIONS_START = "QUICK_ACTIONS_START";
export const QUICK_ACTIONS_FAIL = "QUICK_ACTIONS_FAIL";
export const DASHBOARD_APP_FILTER = "DASHBOARD_APP_FILTER";
export const DASHBOARD_PROCESS_COUNT_LOADER_STATE = "DASHBOARD_PROCESS_COUNT_LOADER_STATE";
export const TASK_FILTER_SUCCESS = "TASK_FILTER_SUCCESS";
export const FILTER_FROM_DASHBOARD = "FILTER_FROM_DASHBOARD";
// App Section

export const APP_SECTION_START = "APP_SET_START";
export const APP_SECTION_COUNT = "APP_SET_COUNT";
export const APP_SECTION_ERROR = "APP_SET_ERROR";
export const APP_SECTION_ID = "APP_SET_ID";
export const APP_DEPLOY_SECTION_COUNT = "APP_DEPLOY_COUNT";
export const START_PROCESS_FORM = "START_PROCESS_FORM";
export const START_PROCESS_ERROR = "START_PROCESS_ERROR";

// all apps

export const ALL_START = "ALL_START";
export const ALL_SUCCESS = "ALL_SUCCESS";
export const ALL_ERROR = "ALL_ERROR";

// charts

export const CHART_START = "CHART_START";
export const CHART_SUCCESS = "CHART_SUCCESS";
export const CHART_FILTER = "CHART_FILTER";
export const CHART_ERROR = "CHART_ERROR";

// show deployed apps
export const SHOW_APP_START = "SHOW_APP_START";
export const SHOW_APP_COUNT = "SHOW_APP_SUCCESS";
export const SHOW_APP_ERROR = "SHOW_APP_ERROR";

// show loader and alert on error

export const LOADER = "LOADER";
export const ALERT_CLOSE = "ALERT_CLOSE";

// users crud Application

export const USER_GET = "USER_GET";
export const USER_CREATE = "USER_CREATE";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_DELETE = "USER_DELETE";
export const USER_UPDATE = "USER_UPDATE";
export const USER_ERROR = "USER_ERROR";
export const USER_GET_ID = "USER_GET_ID";
export const GET_MANAGER = "GET_MANAGER";
export const USER_SEARCH = "SEARCH_USER";
export const SET_USERS_SEARCH = "SET_USERS_SEARCH";
export const CLEAR_USER_SEARCH = "CLEAR_SEARCH_USER";
export const RENDER_USERS_PAGE = "RENDER_USERS_PAGE";

// GROUP crud Application

export const GROUP_LOADER = "GROUP_LOADER";
export const GROUP_GET = "GROUP_GET";
export const GROUP_CREATE = "GROUP_CREATE";
export const GROUP_SUCCESS = "GROUP_SUCCESS";
export const GROUP_DELETE = "GROUP_DELETE";
export const GROUP_UPDATE = "GROUP_UPDATE";
export const GROUP_ERROR = "GROUP_ERROR";
export const GROUP_SEARCH = "GROUP_SEARCH";
export const CLEAR_GROUP_SEARCH = "CLEAR_GROUP_SEARCH";
export const SET_GROUP_SEARCH = "SET_GROUP_SEARCH";

// LOCATION crud Application
export const LOCATION_START = "LOCATION_START";
export const LOCATION_HEAD = "LOCATION_HEAD";
export const LOCATION_GET_SUCCESS = "LOCATION_GET_SUCCESS";
export const LOCATION_CREATE_SUCCESS = "LOCATION_CREATE_SUCCESS";
export const LOCATION_DELETE_SUCCESS = "LOCATION_DELETE_SUCCESS";
export const LOCATION_UPDATE_SUCCESS = "LOCATION_UPDATE_SUCCESS";
export const LOCATION_SEARCH = "LOCATION_SEARCH";
export const LOCATION_ERROR = "LOCATION_ERROR";
export const LOCATION_CLEAR_SEARCH = "LOCATION_CLEAR_SEARCH";
export const SET_LOCN_SEARCH = "SET_LOCN_SEARCH";

// DEPARTMENT crud Application

export const DEPARTMENT_START = "DEPARTMENT_START";
export const DEPARTMENT_GET = "DEPARTMENT_GET";
export const DEPARTMENT_CREATE = "DEPARTMENT_CREATE";
export const DEPARTMENT_SUCCESS = "DEPARTMENT_SUCCESS";
export const DEPARTMENT_DELETE = "DEPARTMENT_DELETE";
export const DEPARTMENT_UPDATE = "DEPARTMENT_UPDATE";
export const DEPARTMENT_ERROR = "DEPARTMENT_ERROR";
export const DEPARTMENT_HEAD = "DEPARTMENT_HEAD";

// // PORTALS crud Application
// export const PORTALS_GET = "PORTALS_GET";
// export const PORTALS_CREATE = "PORTALS_CREATE";
// export const PORTALS_SUCCESS = "PORTALS_SUCCESS";
// export const PORTALS_DELETE = "PORTALS_DELETE";
// export const PORTALS_UPDATE = "PORTALS_UPDATE";
// export const PORTALS_ERROR = "PORTALS_ERROR";

// LIST

export const LIST_SEARCH = "LIST_SEARCH";
export const LIST_CLEAR_SEARCH = "LIST_CLEAR_SEARCH";

// Form io

export const FORM_IO_START = "FORM_IO_START";
export const FORM_IO_SUCCESS = "FORM_IO_SUCCESS";
export const FORM_IO_ERROR = "FORM_IO_ERROR";
// get head
export const HEAD_START = "HEAD_START";
export const HEAD_SUCCESS = "HEAD_SUCCESS";
export const HEAD_ERROR = "HEAD_FAIL";

// get roles
export const GET_ROLES = "GET_ROLES";

// get Process

export const PROCESS_START = "PROCESS_START";
export const PROCESS_SUCCESS = "PROCESS_SUCCESS";
export const PROCESS_DETAILS = "PROCESS_DETAILS";
export const PROCESS_LAUNCH = "PROCESS_LAUNCH";
export const PROCESS_LAUNCH_ERROR = "PROCECSS_LAUNCH_ERROR";
export const PROCESS_ERROR = "PROCESS_ERROR";
export const PROCESS_DETAILS_PAGINATION = "PROCESS_DETAILS_PAGINATION";
export const PROCESS_OPEN_BUCKET = "PROCESS_OPEN_BUCKET";
export const PROCESS_REWORK_BUCKET = "PROCESS_REWORK_BUCKET";
export const PROCESS_ASSIGNED_BUCKET = "PROCESS_ASSIGNED_BUCKET";
export const PROCESS_SUBMITTED_BUCKET = "PROCESS_SUBMITTED_BUCKET";
export const PROCESS_QC_ALLOCATED_BUCKET = "PROCESS_QC_ALLOCATED_BUCKET";
export const PROCESS_QC_DONE_BUCKET = "PROCESS_QC_DONE_BUCKET";
export const PROCESS_QC_REJECTED_BUCKET = "PROCESS_QC_REJECTED_BUCKET";
export const PROCESS_DETAILS_COMPLETED = "PROCESS_DETAILS_COMPLETED";
export const SELECT_DETAILS = "SELECT_DETAILS";
export const SET_DATE_VALUE = "SET_DATE_VALUE";
export const PROCESS_WITHDRAW = "PROCESS_WITHDRAW";
export const GET_TASK_USERS = "GET_TASK_USERS";
export const WITHDRAWN_PROCESS_PAGINATION = "WITHDRAWN_PROCESS_PAGINATION";
export const PROCESS_SEARCH = "PROCESS_SEARCH";
export const PROCESS_SEARCH_COUNT = "PROCESS_SEARCH_COUNT";
export const SELECT_CARD_DETAILS = "SELECT_CARD_DETAILS";
export const SELECT_CARD_ALL = "SELECT_CARD_ALL";
export const CLEAR_ALL = "CLEAR_ALL";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const UPDATE_ADVANCED_FILTER = "UPDATE_ADVANCED_FILTER";
export const UPDATE_ADVANCED_FILTER_TASK = "UPDATE_ADVANCED_FILTER_TASK";
export const TOGGLE_PROCESS_SEARCH_BAR = "TOGGLE_PROCESS_SEARCH_BAR";
export const UPDATE_SEARCH_DATA = "UPDATE_SEARCH_DATA";
export const CLEAR_ALL_PROCESS = "CLEAR_ALL_PROCESS";
export const SET_PROCESS_SIZE = "SET_PROCESS_SIZE";

// get Org logo
export const ORGLOGO_START = "ORGLOGO_START";
export const ORGLOGO_SUCCESS = "ORGLOGO_SUCCESS";
export const ORGLOGO_ERROR = "ORGLOGO_ERROR";
export const ORGTHEME_SUCCESS = "ORGTHEME_SUCCESS";
export const ORGLOGO_UPDATE_SUCCESS = "ORGLOGO_UPDATE_SUCCESS";
export const ORGTHEME_UPDATE_SUCCESS = "ORGTHEME_UPDATE_SUCCESS";
export const ORGADDRESS_UPDATE_SUCCESS = "ORGADDRESS_UPDATE_SUCCESS";

// get profilephoto
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const PROFILEPHOTO_UPDATE_SUCCESS = "PROFILEPHOTO_UPDATE_SUCCESS";
export const PROFILEUPDATE_SUCCESS = "PROFILEUPDATE_SUCCESS";
export const PROFILE_START = "PROFILE_START";

// get signaturephoto
export const SIGNATURE_SUCCESS = "SIGNATURE_SUCCESS";
export const SIGNATURE_ERROR = "SIGNATURE_ERROR";
export const SIGNATUREPHOTO_UPDATE_SUCCESS = "SIGNATUREPHOTO_UPDATE_SUCCESS";
export const SIGNATUREUPDATE_SUCCESS = "SIGNATUREUPDATE_SUCCESS";
export const SIGNATURE_START = "SIGNATURE_START";

// task
export const TASK_START = "TASK_START";
export const TASK_SUCCESS = "TASK_SUCCESS";
export const TASK_ERROR = "TASK_ERROR";
export const TASK_UPDATE = "TASK_UPDATE";
export const TASK_UPDATE_GROUP = "TASK_UPDATE_GROUP";
export const TASK_SUCCESS_PAGINATION = "TASK_SUCCESS_PAGINATION";
export const TASK_FILTER_PAGINATION = "TASK_FILTER_PAGINATION";
export const TASK_SUCCESS_GROUP = "TASK_SUCCESS_GROUP";
export const APP_SUCCESS = "APP_SUCCESS";
export const TASK_CLAIM = "TASK_CLAIM";
export const TASK_GROUP = "TASK_GROUP";
export const MY_TASKS = "MY_TASKS";
export const SEARCH_TASK = "SEARCH_TASK";
export const COUNT_UPDATE = "COUNT_UPDATE";
export const CLEAR_TASK_SEARCH = "CLEAR_TASK_SEARCH";
export const TASK_APPS = "TASK_APPS";
export const TASK_COUNT = "TASK_COUNT";
export const REMOVE_TASK_DATA = "REMOVE_TASK_DATA";

export const CONFIGURE_START = "CONFIGURE_START";
export const CONFIGURE_SUCCESS = "CONFIGURE_SUCCESS";
export const CONFIGURE_ERROR = "CONFIGURE_ERROR";
export const CONFIGURE_UPDATE = "CONFIGURE_UPDATE";

// SMTP Settings
export const SMTP_LOADER = "SMTP_LOADER";
export const GET_SMTP = "GET_SMTP";
export const CREATE_SMTP = "CREATE_SMTP";
export const PATCH_SMTP = "PATCH_SMTP";
export const TEST_SMTP = "TEST_SMTP";
export const ACTIVATION_LINK_SENT = "ACTIVATION_LINK_SENT";
export const ACTIVATION_SUCCESSFULL = "ACTIVATION_SUCCESSFULL";
export const ACTIVATION_FAILURE = "ACTIVATION_FAILURE";
export const ACTIVATION_TIMEOUT = "ACTIVATION_TIMEOUT";
export const ERROR_SMTP = "ERROR_SMTP";
export const CLEAR_SMTP_STATE = "CLEAR_SMTP_STATE";
export const GET_EMAIL_SETTINGS = "GET_EMAIL_SETTINGS";
export const SAVE_SES_SUCCESS = "SAVE_SES_SUCCESS";

export const PORTAL_START = "PORTAL_START";
export const PORTAL_DETAILS = "PORTAL_DETAILS";
export const PORTAL_EDIT = "PORTAL_EDIT";
export const PORTALS_CREATE = "PORTALS_CREATE";
export const PORTALS_ERROR = "PORTALS_ERROR";
export const PORTAL_DETAIL = "PORTAL_DETAIL";
export const PORTAL_CONTENT = "PORTAL_CONTENT";

export const CONTENT_START = "CONTENT_START";
export const CONTENT_DETAILS = "CONTENT_DETAILS";
export const CONTENT_EDIT = "CONTENT_EDIT";
export const CONTENT_CREATE = "CONTENT_CREATE";
export const CONTENT_ERROR = "CONTENT_ERROR";
export const CONTENT_DETAIL = "CONTENT_DETAIL";
export const APPS_LIST = "APPS_LIST";
export const CONTENT_DELETE = "CONTENT_DELETE";

export const CONFIG_VIEW_APPS = "CONFIG_VIEW_APPS";
export const CONFIG_VIEW_ID = "CONFIG_VIEW_ID";
export const CONFIG_VIEW_LOADER = "CONFIG_VIEW_LOADER";
export const CONFIG_VIEW_ERROR = "CONFIG_VIEW_ERROR";
export const CONFIG_VIEW_POST = "CONFIG_VIEW_POST";
export const PROCESS_COUNT_LOADER = "PROCESS_COUNT_LOADER";
export const CONFIG_DASHBOARD_VIEW = "CONFIG_DASHBOARD_VIEW";
export const CONFIG_DASHBOARD_DELETE = "CONFIG_DASHBOARD_DELETE";
export const CONFIG_DASHBOARD_CREATE = "CONFIG_DASHBOARD_CREATE";
export const CONFIG_DASHBOARD_UPDATE = "CONFIG_DASHBOARD_UPDATE";
export const DYNAMIC_CHART_SUCCESS = "DYNAMIC_CHART_SUCCESS";
export const PROCESS_COUNT_SUCCESS = "PROCESS_COUNT_SUCCESS";
export const UNMOUNT_WIDGET_DATA = "UNMOUNT_WIDGET_DATA";
export const DYNAMIC_CHART_FAIL = "DYNAMIC_CHART_FAIL";
export const JOB_EVENT_CONFIG_VIEW_LOADER = "JOB_EVENT_CONFIG_VIEW_LOADER";
export const GET_JOB_CONFIG = "GET_JOB_CONFIG";
export const DELETE_JOB_CONFIG = "DELETE_JOB_CONFIG";
export const GET_EVENT_CONFIG = "GET_EVENT_CONFIG";
export const DELETE_EVENT_CONFIG = "DELETE_EVENT_CONFIG";

// report page

export const REPORT_START = "REPORT_START";
export const REPORT_SUCCESS = "REPORT_SUCCESS";
export const REPORT_FILTER = "REPORT_FILTER";
export const REPORT_ERROR = "REPORT_ERROR";
export const REPORT_APP_SUCCESS = "REPORT_APP_SUCCESS";
export const REPORT_ONBOARDED = "REPORT_ONBOARDED";
export const REPORT_PIE_CHART = "REPORT_PIE_CHART";

export const RETRIEVE_REPORTS = "RETRIEVE_REPORTS";
export const RETRIEVE_REPORT_PAGINATION = "RETRIEVE_REPORT_PAGINATION";
export const DELETE_REPORT = "DELETE_REPORT";

// ASSET CRUD

export const ASSET_START = "ASSET_START";
export const ASSET_GET_SUCCESS = "ASSET_GET_SUCCESS";
export const ASSET_CREATE_SUCCESS = "ASSET_CREATE_SUCCESS";
export const ASSET_DELETE_SUCCESS = "ASSET_DELETE_SUCCESS";
export const ASSET_UPDATE_SUCCESS = "ASSET_UPDATE_SUCCESS";
export const ASSET_ERROR = "ASSET_ERROR";

// KIT CRUD

export const KIT_START = "KIT_START";
export const KIT_GET_SUCCESS = "KIT_GET_SUCCESS";
export const KIT_CREATE_SUCCESS = "KIT_CREATE_SUCCESS";
export const KIT_UPDATE_SUCCESS = "KIT_UPDATE_SUCCESS";
export const KIT_ERROR = "KIT_ERROR";
export const KIT_DELETE_SUCCESS = "KIT_DELETE_SUCCESS";

// Stock R

export const STOCK_START = "STOCK_START";
export const STOCK_GET_SUCCESS = "STOCK_GET_SUCCESS";
export const STOCK_ERROR = "STOCK_ERROR";

// Stock Adjust R

export const STOCK_ADJUST_START = "STOCK_ADJUST_START";
export const STOCK_ADJUST_GET_SUCCESS = "STOCK_ADJUST_GET_SUCCESS";
export const STOCK_ADJUST_ERROR = "STOCK_ADJUST_ERROR";

// DISTRIBUTION CR

export const DISTRIBUTION_START = "DISTRIBUTION_START";
export const DISTRIBUTION_GET_SUCCESS = "DISTRIBUTION_GET_SUCCESS";
export const DISTRIBUTION_CREATE_SUCCESS = "DISTRIBUTION_CREATE_SUCCESS";
export const DISTRIBUTION_ERROR = "DISTRIBUTION_ERROR";
export const DISTRIBUTION_SEARCH_FIELDS_SUCCESS = "DISTRIBUTION_SEARCH_FIELDS_SUCCESS";
export const SET_DISTRIBUTION_SEARCH = "SET_DISTRIBUTION_SEARCH";
export const CLEAR_DISTRIBUTION_SEARCH = "CLEAR_DISTRIBUTION_SEARCH";

// SUPPLIER CRUD

export const SUPPLIER_START = "SUPPLIER_START";
export const SUPPLIER_GET_SUCCESS = "SUPPLIER_GET_SUCCESS";
export const SUPPLIER_CREATE_SUCCESS = "SUPPLIER_CREATE_SUCCESS";
export const SUPPLIER_DELETE_SUCCESS = "SUPPLIER_DELETE_SUCCESS";
export const SUPPLIER_UPDATE_SUCCESS = "SUPPLIER_UPDATE_SUCCESS";
export const SUPPLIER_ERROR = "SUPPLIER_ERROR";

// SUPPLY CRUD

export const SUPPLY_START = "SUPPLY_START";
export const SUPPLY_GET_SUCCESS = "SUPPLY_GET_SUCCESS";
export const SUPPLY_CREATE_SUCCESS = "SUPPLY_CREATE_SUCCESS";
export const SUPPLY_DELETE_SUCCESS = "SUPPLY_DELETE_SUCCESS";
export const SUPPLY_UPDATE_SUCCESS = "SUPPLY_UPDATE_SUCCESS";
export const SUPPLY_ERROR = "SUPPLY_ERROR";

// Master DB

export const MASTER_DB_LOADER = "MASTER_DB_LOADER";
export const MASTER_DB_GET = "MASTER_DB_GET";
export const MASTER_DB_POST_MODEL = "MASTER_DB_POST";
export const MASTER_DB_DELETE_MODEL = "MASTER_DB_DELETE_MODEL";
export const MASTER_DB_GET_MODEL = "MASTER_DB_GET_MODEL";
export const MASTER_DB_GET_MODEL_BY_ID = "MASTER_DB_GET_MODEL_BY_ID";
export const MASTER_DB_POST_FIELD = "MASTER_DB_POST_FIELD";
export const MASTER_DB_EDIT_FIELD = "MASTER_DB_EDIT_FIELD";
export const MASTER_DB_DELETE_FIELD = "MASTER_DB_DELETE_FIELD";
export const MASTER_DB_ERROR = "MASTER_DB_ERROR";
export const MASTER_DB_CLEAR = "MASTER_DB_CLEAR";
export const MASTER_RECORDS_GET = "MASTER_RECORDS_GET";
export const MASTER_RECORDS_EDIT = "MASTER_RECORDS_EDIT";
export const MASTER_RECORDS_DELETE = "MASTER_RECORDS_DELETE";
export const MASTER_ENTITY_DATA_BY_ID = "MASTER_ENTITY_DATA_BY_ID";
export const MASTER_RECORDS_DOWNLOAD = "MASTER_RECORDS_DOWNLOAD";

// Custom Data

export const CUSTOM_DATA_LOADER = "CUSTOM_DATA_LOADER";
export const CUSTOM_DATA_GET = "CUSTOM_DATA_GET";
export const CUSTOM_DATA_POST = "CUSTOM_DATA_POST";
export const CUSTOM_DATA_EDIT = "CUSTOM_DATA_EDIT";
export const CUSTOM_DATA_ERROR = "CUSTOM_DATA_ERROR";
export const CUSTOM_DATA_GET_BY_ID = "CUSTOM_DATA_GET_BY_ID";
export const CUSTOM_DATA_DELETE = "CUSTOM_DATA_DELETE";
export const SET_CUSTOM_DATA_SEARCH = "SET_CUSTOM_DATA_SEARCH";

// Task Lists

export const GET_USER_TASK_LIST = "GET_USER_TASK_LIST";

export const GET_USER_INVOLVED_GROUP = "GET_USER_INVOLVED_GROUP";

// Advanced List

export const SEARCH_ADVANCED_LIST = "SEARCH_ADVANCED_LIST";
export const GET_ADVANCED_LIST_DATA = "GET_ADVANCED_LIST_DATA";
export const SET_ADVANCED_LIST_LOADER = "SET_ADVANCED_LIST_LOADER";
export const CLEAR_ADVANCED_LIST_SEARCH = "CLEAR_ADVANCED_LIST_SEARCH";

// websocket
export const WEBSOCKET_NOTIFICATION = "WEBSOCKET_NOTIFICATION";
export const WEBSOCKET_UPDATES = "WEBSOCKET_UPDATES";
export const CHANGE_BELL_VIBRATE = "CHANGE_BELL_VIBRATE";
export const NOTIFICATIONS_CLICKED = "NOTIFICATIONS_CLICKED";
export const NOTIFICATION_LOADER = "NOTIFICATION_LOADER";
export const NOTIFICATION_PAGE = "NOTIFICATION_PAGE";

// Entity
export const GET_ENTITY_LIST = "GET_ENTITY_LIST";
export const ENTITY_LOADER = "ENTITY_LOADER";
export const GET_ENTITY_SEARCH = "GET_ENTITY_SEARCH";
export const SET_ENTITY_SEARCH = "SET_ENTITY_SEARCH";
export const ENTITY_ERROR = "ENTITY_ERROR";
export const ENTITY_SEARCH_CLEAR = "ENTITY_SEARCH_CLEAR";
export const TOGGLE_ENTITY_SEARCH_BAR = "TOGGLE_ENTITY_SEARCH_BAR";

// BGV
export const SET_BGV_SEARCH = "SET_BGV_SEARCH";
export const CLEAR_BGV_SEARCH = "CLEAR_BGV_SEARCH";

// HIRING
export const SET_LOADER = "SET_LOADER";
export const GET_HEADCOUNT = "GET_HEADCOUNT";
export const GET_TOP_SOURCE = "GET_TOP_SOURCE";
export const GET_TOTAL_EVENTS = "GET_TOTAL_EVENTS";
export const GET_TOTAL_FILLED = "GET_TOTAL_FILLED";
export const GET_TOTAL_OPENINGS = "GET_TOTAL_OPENINGS";
export const GET_TOTAL_REMAINING = "GET_TOTAL_REMAINING";

// JOBS
export const GET_JOBS = "GET_JOBS";
export const EDIT_JOB = "EDIT_JOB";
export const DELETE_JOB = "DELETE_JOB";
export const SET_JOB_LOADER = "SET_JOB_LOADER";
export const JOB_ERROR = "JOB_ERROR";

// JOB VIEW
export const GET_JOB = "GET_JOB";
export const GET_JOB_CANDIDATES = "GET_JOB_CANDIDATES";
export const SET_JOB_VIEW_LOADER = "SET_JOB_VIEW_LOADER";
export const CLEAR_JOB_CANDIDATES = "CLEAR_JOB_CANDIDATES";

// Hiring Event
export const HIRING_EVENT_GET_SUCCESS = "HIRING_EVENT_GET_SUCCESS";
export const HIRING_EVENT_UPDATE_SUCCESS = "HIRING_EVENT_UPDATE_SUCCESS";
export const HIRING_EVENT_DELETE_SUCCESS = "HIRING_EVENT_DELETE_SUCCESS";
export const HIRING_EVENT_ERROR = "HIRING_EVENT_ERROR";
export const HIRING_EVENT_CREATE_SUCCESS = "HIRING_EVENT_CREATE_SUCCESS";
export const HIRING_EVENT_START = "HIRING_EVENT_START";

// Partner
export const HIRING_PARTNER_GET_SUCCESS = "HIRING_PARTNER_GET_SUCCESS";
export const HIRING_PARTNER_UPDATE_SUCCESS = "HIRING_PARTNER_UPDATE_SUCCESS";
export const HIRING_PARTNER_DELETE_SUCCESS = "HIRING_PARTNER_DELETE_SUCCESS";
export const HIRING_PARTNER_ERROR = "HIRING_PARTNER_ERROR";
export const HIRING_PARTNER_CREATE_SUCCESS = "HIRING_PARTNER_CREATE_SUCCESS";
export const HIRING_PARTNER_START = "HIRING_PARTNER_START";

// Head Count
export const GET_HEAD_COUNTS = "GET_HEAD_COUNTS";
export const SET_HEAD_COUNT_LOADER = "SET_HEAD_COUNT_LOADER";
export const SET_HEAD_COUNT_ROLE_LOCATION_DATA = "SET_HEAD_COUNT_ROLE_LOCATION_DATA";

// Job Role
export const JOB_ROLE_GET_SUCCESS = "JOB_ROLE_GET_SUCCESS";
export const JOB_ROLE_UPDATE_SUCCESS = "JOB_ROLE_UPDATE_SUCCESS";
export const JOB_ROLE_DELETE_SUCCESS = "JOB_ROLE_DELETE_SUCCESS";
export const JOB_ROLE_ERROR = "JOB_ROLE_ERROR";
export const JOB_ROLE_CREATE_SUCCESS = "JOB_ROLE_CREATE_SUCCESS";
export const JOB_ROLE_START = "JOB_ROLE_START";

// Job Portal
export const JOB_PORTAL_GET_JOB = "JOB_PORTAL_GET_JOB";
export const JOB_PORTAL_GET_JOBS = "JOB_PORTAL_GET_JOBS";
export const SET_JOB_PORTAL_LOADER = "SET_JOB_PORTAL_LOADER";
export const SET_JOB_PORTAL_LOCATIONS = "SET_JOB_PORTAL_LOCATIONS";
export const JOB_PORTAL_GET_JOB_ROLES = "JOB_PORTAL_GET_JOB_ROLES";

// Task Adv Filter

export const UPDATE_TASK_FILTER_QUERY = "JOB_PORTAL_GET_JOB_ROLES";
